import React from 'react';
import { ConnectionLineComponentProps, getSmoothStepPath } from 'reactflow';
import { useCanvasStore } from '../stores/canvasStore.js';
import { getTypeColor } from '../utils/typeColors.js';
import { widgetRegistry } from '../utils/widgetRegistry.js';

export const ConnectionLine: React.FC<ConnectionLineComponentProps> = ({
  fromX,
  fromY,
  toX,
  toY,
  fromPosition,
  toPosition,
  fromNode,
  fromHandle,
}) => {
  // Get the source widget and output definition to determine color
  const activeCanvas = useCanvasStore((state) => state.getActiveCanvas());
  const sourceWidget = activeCanvas?.widgets.find(w => w.id === fromNode?.id);
  const sourceWidgetDef = sourceWidget ? widgetRegistry.get(sourceWidget.type) : undefined;
  const outputDef = sourceWidgetDef?.outputDefinitions?.find(def => def.id === fromHandle?.id);
  const lineColor = getTypeColor(outputDef?.schema);

  const [edgePath] = getSmoothStepPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  });

  return (
    <g>
      {/* Outer glow */}
      <path
        fill="none"
        stroke={lineColor}
        strokeWidth={6}
        d={edgePath}
        opacity={0.2}
      />
      <path
        fill="none"
        stroke={lineColor}
        strokeWidth={2}
        d={edgePath}
        style={{
          strokeDasharray: 5,
          animation: 'dashdraw 0.5s linear infinite',
        }}
      />
      <style>
        {`
          @keyframes dashdraw {
            0% {
              stroke-dashoffset: 10;
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
        `}
      </style>
    </g>
  );
};